import Vue from 'vue';
import Router from 'vue-router';

import DesignEditor from './views/designEditor/designEditor.vue';
import DesignEditor_m from './views/designEditor/designEditor_m.vue';
import LayoutEditor from './views/layoutEditor/layoutEditor.vue';
import LayoutEditor_m from './views/layoutEditor/layoutEditor_m.vue';
import PrintSetting from './views/printSetting/printSetting.vue';
import PrintSetting_m from './views/printSetting/printSetting_m.vue';
import InsertionEditor from './views/insertionEditor/insertionEditor.vue';
import SelectInsertionDesign from './views/selectInsertionDesign/selectInsertionDesign.vue';
import TrimEditor from './views/_mobile/trimEditor/trimEditor.vue';
import BlankView from './views/_mobile/blankView/blankView.vue';
// import PlugDesign from './views/plugDesign/plugDesign.vue';
import Top2 from './views/top2/top.vue';
import Cloud from "./views/cloud/cloud.vue";
import Sns from "./views/sns/sns.vue";
import Sns_m from "./views/sns/sns_m.vue";

import SelectPage from './views/selectPage/selectPage.vue';
import SelectTemplate from './views/selectTemplate/selectTemplate.vue';

import NewsAll from './views/newsAll/newsAll.vue';

import SignIn from './views/signIn/signIn.vue';
import UserRegistration from './views/userRegistration/userRegistration.vue';

import { UserAgentHelper } from '@/helper/userAgentHelper';

// import Crypto from './views/test/crypto/crypto.vue';

Vue.use(Router);

export default new Router({
    // mode: 'history', // urlの#を消す
    routes: [
        {
            path: '/',
            name: 'Top2',
            component: Top2
        },
        {
            path: '/DesignEditor',
            name: 'DesignEditor',
            component: UserAgentHelper.isMobile() ? DesignEditor_m : DesignEditor
        },
        {
            path: '/InsertionEditor',
            name: 'InsertionEditor',
            component: InsertionEditor,
        },
        {
            path: '/LayoutEditor',
            name: 'LayoutEditor',
            component: UserAgentHelper.isMobile() ? LayoutEditor_m : LayoutEditor,
        },
        {
            path: '/PrintSetting',
            name: 'PrintSetting',
            component: UserAgentHelper.isMobile() ? PrintSetting_m : PrintSetting,
        },
        {
            path: '/SelectPage',
            name: 'selectPage',
            component: SelectPage,
        },
        {
            path: '/SelectTemplate',
            name: 'selectTemplate',
            component: SelectTemplate,
        },
        {
            path: '/SelectInsertionDesign',
            name: 'selectInsertionDesign',
            component: SelectInsertionDesign,
        },
        {
            path: '/Cloud',
            name: 'cloud',
            component: Cloud,
        },
        {
            path: '/Sns',
            name: 'sns',
            component: UserAgentHelper.isMobile() ? Sns_m : Sns,
        },
        {
            path: '/NewsAll',
            name: 'newsAll',
            component: NewsAll,
        },
        {
            path: '/SignIn',
            name: 'signIn',
            component: SignIn,
        },
        {
            path: '/UserRegistration',
            name: 'userRegistration',
            component: UserRegistration,
        },
        {
            path: '/TrimEditor',
            name: 'TrimEditor',
            component: TrimEditor
        },
        {
            path: '/BlankView',
            name: 'BlankView',
            component: BlankView
        }
    ],
});
